// @ts-strict-ignore
import React, { useContext, useMemo } from 'react';
import {
  getMLAFootnoteNumber,
} from './helpers';
import { RuleBuilderContext } from '../../context';
import { ThresholdContext } from './context';
import { StyledSuperset } from 'flow/editor/components/mla/styles';
import type { MLAType } from 'flow/service/mla';


const MLASuperset = ({ type }: { type: (typeof MLAType)[keyof typeof MLAType] }) => {
  const { rulesWithMLA } = useContext(RuleBuilderContext);
  const { populatedThreshold } = useContext(ThresholdContext);

  const mlaFootnoteNumber = useMemo(() => getMLAFootnoteNumber(
    rulesWithMLA,
    populatedThreshold,
    type,
  ), [rulesWithMLA, populatedThreshold, type]);

  return (mlaFootnoteNumber !== undefined && mlaFootnoteNumber > -1
    ? <StyledSuperset>{mlaFootnoteNumber + 1}</StyledSuperset>
    : null);
};

export default MLASuperset;
